<template>
  <div class="my-cryptic-container">
    <el-header>
      <h1>My Knowits</h1>
    </el-header>
    <el-main>
      <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleTabClick">
        <el-tab-pane label="Private" name="private">
          <div class="posts-container">
            <Post
              v-for="draft in drafts"
              :key="draft.id"
              :post="draft || {}"
              @edit="editDraft"
            />
            
            <div v-if="drafts.length === 0" class="empty-state">
              <p>No private knowits found.</p>
              <el-button type="primary" @click="$router.push('/new-knowit')">
                Create Your First Knowit
              </el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Acquired" name="acquired">
          <div class="posts-container">
            <Post
              v-for="post in acquiredPosts"
              :key="post.id"
              :post="post || {}"
              @like="handleLike"
              @comment="handleComment"
            />
            <div v-if="acquiredPosts.length === 0" class="empty-state">
              <p>You haven't acquired any Knowit yet.</p>
              <el-button type="primary" @click="$router.push('/square')">
                Visit Square
              </el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Posted" name="posts">
          <div class="posts-container">
            <Post
              v-for="post in posted"
              :key="post.id"
              :post="post || {}"
              @like="handleLike"
              @comment="handleComment"
            />
            <div v-if="posted.length === 0" class="empty-state">
              <p>You haven't posted any Knowits yet.</p>
              <el-button type="primary" @click="goToNewKnowit" v-if="drafts.length === 0">
                Create Your First Knowit
              </el-button>
              
              <p v-if="drafts.length > 0">Select one of your private or draft Knowits to post</p>
            </div>
          </div>
        </el-tab-pane>
        
        

        
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
import Post from '@/components/Post.vue'
import { postRequest } from '@/apis/front'

export default {
  name: 'MyCryptic',
  components: {
    Post
  },
  data() {
    return {
      activeTab: localStorage.getItem('myCrypticTab') || 'posts',
      myPosts: [],
      posted:[],
      drafts: [],
      solvedPosts: [],
      acquiredPosts: []
    }
  },
  mounted() {
    // TODO: Fetch user's posts, drafts, and solved posts from API
    this.fetchMyPosts()
    this.fetchDrafts()
    this.fetchSolvedPosts()
    this.fetchAcquiredPosts()
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab.paneName
      localStorage.setItem('myCrypticTab', tab.paneName)
    },
    fetchMyPosts() {
      // TODO: API call to get user's posts
      const params = {
        user_id: this.$store.state.user_id,
        time_stamp: Math.floor(Date.now() / 1000)
      }

      postRequest('getMyPosts', params).then(response => {
        if (response.data.code === 0) {
          this.myPosts = response.data.data
          this.posted = this.myPosts.filter(post => post.status === 'PUBLISHED')
          this.drafts = this.myPosts.filter(post => post.status === 'DRAFT' || post.status === 'PRIVATE')
        } else {
          this.$message.error(response.msg || 'Failed to fetch posts')
        }
      }).catch(error => {
        console.error('Error fetching posts:', error)
        this.$message.error('Failed to fetch posts')
      })
      
      
      // this.myPosts = [
      //   {
      //     id: 1,
      //     title: 'My Sample Cryptic',
      //     content: 'This is a cryptic I created...',
      //     authorName: this.$store.state.user_info.student_lastName + ' ' + this.$store.state.user_info.student_givenName,
      //     createdAt: new Date().toISOString(),
      //     likes: 5,
      //     comments: 2
      //   }
      // ]
    },
    fetchDrafts() {
      // TODO: API call to get drafts
      this.drafts = []
    },
    fetchSolvedPosts() {
      // TODO: API call to get solved posts
      this.solvedPosts = []
    },
    handleLike(postId) {
      console.log('Like post:', postId)
    },
    handleComment(postId) {
      console.log('Comment on post:', postId)
    },
    editDraft(draftId) {
      this.$router.push(`/edit-cryptic/${draftId}`)
    },
    fetchAcquiredPosts() {
      const params = {
        user_id: this.$store.state.user_id
      }

      postRequest('getAcquiredPosts', params).then(response => {
        if (response.data.code === 0) {
          this.acquiredPosts = response.data.data
        } else {
          this.$message.error(response.msg || 'Failed to fetch acquired posts')
        }
      }).catch(error => {
        console.error('Error fetching acquired posts:', error)
        this.$message.error('Failed to fetch acquired posts') 
      })
    },
    goToNewKnowit() {
      localStorage.setItem('editPostId', '')
      this.$router.push('/new-knowit')
    },
  }
}
</script>

<style scoped>
.my-cryptic-container {
  width: 100%;
}

.el-header {
  background-color: #409EFF;
  color: white;
  text-align: center;
  padding: 5px 0;
  width: 100%;
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-main {
  padding: 20px;
  width: 100%;
}

.posts-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, max-content));
  gap: 20px;
  justify-content: start;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #909399;
  grid-column: 1 / -1;
}

.empty-state p {
  margin-bottom: 20px;
}
</style> 